module.exports = __webpack_public_path__ + "img/image_3.c1f96369.jpg";